import React from 'react';
import styled from '@emotion/styled';
const truncateCommonStyles = `
  display: inline-block;
  vertical-align: bottom;
  white-space: nowrap;
  overflow: hidden;
`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation
export const TruncateLeft = styled.span`
  ${truncateCommonStyles}
  max-width: calc(100% - ${({
  fontSizePX,
  endFixedChars
}) => fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em);
  min-width: ${({
  fontSizePX,
  startFixedChars
}) => fontFaceScaleFactor(fontSizePX) * startFixedChars};
  text-overflow: ellipsis;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation
export const TruncateRight = styled.span`
  ${truncateCommonStyles}
  max-width: calc(100% - ${({
  fontSizePX,
  startFixedChars
}) => fontFaceScaleFactor(fontSizePX) * startFixedChars});
  position: relative;
`;
export const calculateTruncation = (text, startFixedChars, endFixedChars) => {
  const minAllowedLength = endFixedChars + startFixedChars;
  if (text.length <= minAllowedLength) {
    // if no truncation return same value for left and right
    return {
      left: text,
      right: text
    };
  }
  const splitAt = text.length - endFixedChars;
  const left = text.substr(0, splitAt);
  const right = text.substr(splitAt);
  return {
    left,
    right
  };
};
const fontFaceScaleFactor = fontSizePX => fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */

export const Truncate = ({
  text,
  fontSizePX = 11,
  // Must be calibrated with fontSize
  startFixedChars = 4,
  // 1 char + 3 dots
  endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
}) => {
  const {
    left: leftStr,
    right: rightStr
  } = calculateTruncation(text, startFixedChars, endFixedChars);
  if (leftStr === rightStr) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, text);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TruncateLeft, {
    fontSizePX: fontSizePX,
    startFixedChars: startFixedChars,
    endFixedChars: endFixedChars
  }, leftStr), /*#__PURE__*/React.createElement(TruncateRight, {
    fontSizePX: fontSizePX,
    startFixedChars: startFixedChars,
    endFixedChars: endFixedChars
  }, rightStr));
};